// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zCopyRfpIntakeResponse = z.object({
    rfpId: z.number().int(),
    rfpUuid: z.string().uuid(),
    ecosystemId: z.string().uuid(),
    census: z.enum([
        'copied',
        'read',
        'none'
    ]),
    censusOutcome: z.enum([
        'parsed',
        'encrypted',
        'legacy-workbook',
        'unreadable',
        'no-header-row',
        'no-identity-columns',
        'no-members'
    ]).optional(),
    censusMembers: z.number().int()
});

export const zCensusReadStatusResponse = z.object({
    ingestionId: z.number().int(),
    source: z.string(),
    outcome: z.string(),
    readAt: z.string().datetime().optional()
});

export const zUploadCensusDocumentResponse = z.object({
    documentId: z.number().int(),
    filename: z.string(),
    size: z.number().int()
});

export const zUnreadableValueGroup = z.object({
    value: z.string().optional(),
    rows: z.array(z.number().int())
});

/**
 * One change to the file. `addColumn` and `fillColumn` set `field`,
 * `lines` and `headers`; `fillColumn` also sets `rows`. `fixValues` sets
 * `column` and `values`.
 *
 */
export const zCensusSuggestion = z.object({
    kind: z.enum([
        'addColumn',
        'fillColumn',
        'fixValues'
    ]),
    field: z.string().optional(),
    lines: z.array(z.string()).optional(),
    headers: z.array(z.string()).optional(),
    rows: z.array(z.number().int()).optional(),
    column: z.string().optional(),
    values: z.array(zUnreadableValueGroup).optional()
});

/**
 * What a broker is told about one census file.
 */
export const zCensusCheckResponse = z.object({
    outcome: z.enum([
        'parsed',
        'encrypted',
        'legacy-workbook',
        'unreadable',
        'no-header-row',
        'no-identity-columns',
        'no-members'
    ]),
    employees: z.number().int(),
    lines: z.array(z.string()),
    suggestions: z.array(zCensusSuggestion),
    unmappedHeaders: z.array(z.string()),
    documentId: z.number().int(),
    checkedAt: z.string().datetime()
});

export const zUnreadableColumn = z.object({
    column: z.string(),
    values: z.array(zUnreadableValueGroup)
});

/**
 * What the census said about one coverage for each employee. Every
 * employee falls in exactly one of enrolled, waived, unreadable and
 * notStated, so the four add up to the census's employees.
 *
 */
export const zCoverageEnrollment = z.object({
    coverage: z.enum([
        'dental',
        'vision',
        'std',
        'ltd',
        'basicLife',
        'voluntaryLife',
        'adnd'
    ]),
    enrolled: z.number().int(),
    waived: z.number().int(),
    unreadable: z.number().int(),
    notStated: z.number().int(),
    brokerEnrolled: z.number().int().optional()
});

export const zCensusFieldCheck = z.object({
    field: z.enum([
        'dateOfBirth',
        'gender',
        'elections',
        'class',
        'homeZip',
        'salary',
        'occupation',
        'electedVolumes',
        'workZip',
        'workState',
        'w2Employees'
    ]),
    status: z.enum([
        'complete',
        'partial',
        'missing',
        'unread',
        'notInCensus'
    ]),
    missingMembers: z.number().int(),
    readFrom: z.array(z.string()).optional(),
    preferredHeaders: z.array(z.string()).optional()
});

export const zCensusLineCheck = z.object({
    line: z.enum([
        'Dental',
        'Vision',
        'STD / LTD',
        'Basic Life',
        'Voluntary Life',
        'FMLA',
        'State Disability'
    ]),
    checks: z.array(zCensusFieldCheck),
    passed: z.number().int(),
    total: z.number().int(),
    enrollment: z.array(zCoverageEnrollment)
});

/**
 * Where the census came from and how it was read. Absent until a read has been attempted.
 */
export const zCensusSourceDetail = z.object({
    ingestionId: z.number().int(),
    source: z.string(),
    outcome: z.string(),
    readAt: z.string().datetime().optional(),
    filename: z.string().optional(),
    documentUrl: z.string().optional(),
    sheetName: z.string().optional(),
    headerRow: z.number().int().optional()
});

export const zCensusValidationResponse = z.object({
    members: z.number().int(),
    employees: z.number().int(),
    lines: z.array(zCensusLineCheck),
    unmappedHeaders: z.array(z.string()),
    coercionFailures: z.record(z.number().int()).optional(),
    unreadableValues: z.array(zUnreadableColumn).optional(),
    source: zCensusSourceDetail.optional()
});

export const zEcosystemIdResponse = z.object({
    ecosystemId: z.string().uuid()
});

export const zBpRfpIdResponse = z.object({
    id: z.number().int()
});

export const zSdlStateOption = z.object({
    code: z.string().nullable(),
    value: z.string().nullable()
});

export const zSdlStateCoverage = z.object({
    name: z.string().nullable(),
    options: z.array(zSdlStateOption)
});

export const zSdlCoverageDetails = z.object({
    name: z.string().nullish(),
    enrolledLives: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    requestedCommission: z.string().nullish(),
    currentCommission: z.string().nullish(),
    additionalNotes: z.string().nullish()
});

export const zSdlCoverageResponse = z.object({
    id: z.number().int(),
    rfpId: z.number().int().nullable(),
    productId: z.number().int().nullable(),
    isCurrent: z.boolean().nullable(),
    sfExternalId: z.string().nullable(),
    states: z.array(zSdlStateCoverage),
    details: zSdlCoverageDetails
});

export const zCoverageCarriersResponse = z.object({
    productName: z.string(),
    currentCarrier: z.string().optional(),
    carriers: z.array(z.string())
});

export const zMarketingPresentationInfoResponse = z.object({
    brokerId: z.string(),
    brokerName: z.string().optional(),
    companyName: z.string().optional(),
    addressLine1: z.string().optional(),
    addressLine2: z.string().optional(),
    effectiveDate: z.string().optional(),
    eligibleLives: z.number().int().optional(),
    producer: z.string().optional(),
    consultantName: z.string().optional(),
    accountManager: z.string().optional(),
    linesOfCoverage: z.string().optional(),
    coverageCarriers: z.array(zCoverageCarriersResponse).optional()
});

export const zAppError = z.object({
    errorId: z.string().uuid(),
    timestamp: z.string().datetime(),
    statusCode: z.number().int().optional(),
    message: z.string().optional(),
    operation: z.string().optional(),
    objectType: z.string().optional(),
    objectId: z.string().optional(),
    attributes: z.record(z.unknown()).optional()
});

export const zErrorResponse = z.object({
    errorMessage: z.string(),
    error: z.string().nullish(),
    appError: zAppError
});

export const zGetEcosystemIdByBpRfpIdPath = z.object({
    id: z.number().int()
});

/**
 * Ecosystem RFP ID found
 */
export const zGetEcosystemIdByBpRfpIdResponse = zEcosystemIdResponse;

export const zGetBpRfpIdByEcosystemIdPath = z.object({
    ecoId: z.string().uuid()
});

/**
 * BP RFP ID found
 */
export const zGetBpRfpIdByEcosystemIdResponse = zBpRfpIdResponse;

export const zGetSdlRfpCoverageByEcosystemIdQuery = z.object({
    ecoId: z.string().uuid()
});

/**
 * SDL coverage found
 */
export const zGetSdlRfpCoverageByEcosystemIdResponse = zSdlCoverageResponse;

export const zGetMarketingPresentationInfoPath = z.object({
    id: z.string()
});

/**
 * Marketing presentation info found
 */
export const zGetMarketingPresentationInfoResponse = zMarketingPresentationInfoResponse;

export const zGetRfpCensusValidationPath = z.object({
    id: z.number().int()
});

/**
 * Census validation for the RFP
 */
export const zGetRfpCensusValidationResponse = zCensusValidationResponse;

export const zUploadRfpCensusDocumentBody = z.object({
    file: z.instanceof(Blob),
    name: z.string().optional()
});

export const zUploadRfpCensusDocumentPath = z.object({
    id: z.number().int()
});

/**
 * Stored, and reading has started
 */
export const zUploadRfpCensusDocumentResponse = zUploadCensusDocumentResponse;

export const zGetRfpCensusReadStatusPath = z.object({
    id: z.number().int()
});

export const zGetRfpCensusReadStatusQuery = z.object({
    documentId: z.number().int().optional()
});

export const zGetRfpCensusReadStatusResponse = z.union([
    zCensusReadStatusResponse,
    z.void()
]);

export const zCheckRfpCensusDocumentPath = z.object({
    id: z.number().int(),
    documentId: z.number().int()
});

/**
 * The check of this document against the RFP's current products
 */
export const zCheckRfpCensusDocumentResponse = zCensusCheckResponse;

/**
 * The template workbook, as an attachment named `Census template.xlsx`
 */
export const zDownloadCensusTemplateResponse = z.instanceof(Blob);

export const zCopyRfpIntakePath = z.object({
    id: z.string()
});

/**
 * The intake copy was created
 */
export const zCopyRfpIntakeResponse2 = zCopyRfpIntakeResponse;
